import React from 'react'

import 'primereact/resources/primereact.min.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import 'primeicons/primeicons.css'
import { ToastContainer } from 'react-toastify/dist/react-toastify'

const queryClient = new QueryClient()

export const HOC = (Component) => {
  const HOCWrapper = (props) => (
    <>
      <QueryClientProvider client={queryClient}>
        <Component {...props} />
        <ToastContainer position="bottom-right" />
      </QueryClientProvider>
    </>
  )

  return HOCWrapper
}

export const HOCWrapper = ({ children }) => (
  <>
    <QueryClientProvider client={queryClient}>
      {children}
      <ToastContainer position="bottom-right" />
    </QueryClientProvider>
  </>
)

export default HOC
